import { createAction } from 'redux-actions';

export const APP_SET_HOLDING_COMPANY = 'APP_SET_HOLDING_COMPANY';
export const APP_SET_ACTIVE = 'APP_SET_ACTIVE';
export const APP_NETWORK_STATE_CHANGED = 'APP_NETWORK_STATE_CHANGED';
export const APP_ONLINE_STATE_CHANGED = 'APP_ONLINE_STATE_CHANGED';

export default {
  setHoldingCompany: createAction(APP_SET_HOLDING_COMPANY),
  setActive: createAction(APP_SET_ACTIVE),
  // More info: https://github.com/react-native-community/react-native-netinfo#api
  changeNetworkState: createAction(APP_NETWORK_STATE_CHANGED),
  changeOnlineState: createAction(APP_ONLINE_STATE_CHANGED),
};
